import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import dataScientist from '../../../js/pages/JobsListPage/dataScientistJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={dataScientist} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(dataScientist);
export const getStaticPaths = makeStaticPaths(dataScientist);
